<script>
import { eventBus } from "../main";
import navigation from "../mixins/navigation.js";
export default {
  mixins: [navigation],
  name: "app",
  data() {
    return {
      last: "P_9",
      next: "P_11",
      topic: "Taller Conoce el Crédito / ¡Quiero saber qué es y para qué sirve un crédito!",
      progress: false
    };
  },
  methods: {

  }
};
</script>

<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs11, sm10, md10, lg9)
          v-card(flat, text-xs-center)
            breadcrumb(:back='last') Estás en: {{topic}}
            v-card-text.text-xs-center.label16tt.withDivider(style='color:#F7893B')
              | ESCENARIO
            v-layout(row, wrap, justify-start, py-4)
              v-flex.ma-0.pa-0(xs12, md6)
                v-card.pa-5(flat, height='100%', color='secondary')
                  .parrafoDestacadoW
                    b Juan 
                    | es tu mejor amigo y confía mucho en ti. 
                    .pt-3 Siempre te ha consultado decisiones difíciles en su vida. Ahora, Juan te cuenta que un amigo suyo necesita un préstamo de dinero de manera urgente y no sabe si dárselo. No es cualquier cantidad de dinero, su amigo le está pidiendo 
                    b $50,000. 
                    | Por fortuna Juan tiene ese dinero ahorrado y no lo piensa usar pronto; podría prestárselo a su amigo, pero no sabe si confiar en que le pagará. 
                    b Le gustaría saber qué debe tomar en cuenta para otorgarle el préstamo. 
                  v-icon.pt-3.pr-3(color="white") fas fa-bolt
                  span.parrafoDestacadoW
                    b Información para decidir:
                    |  Cuando realizas un préstamo es importante asegurarte de que esa persona sabe cómo manejarlo. 
              v-flex.ma-0.pa-0(xs12, md6)
                v-card(flat, text-xs-start)
                  v-img(height='600px', :src='require("@/assets/TCC-L3-Pagina2 A.png")')
            v-layout(row, justify-center)
              v-btn.btn(justify-space-between, type='button', color='accent', @click.prevent="nextPage(next)")
                | Siguiente
          l-progress(:value='this.$parent.currentPage')
</template>


